module.exports = __webpack_public_path__ + "img/signs14.9516d800.jpg";